import React, { useEffect, useRef } from "react";
import "./MentionsLegales.css";

const sections = [
  {
    number: "01",
    title: "Éditeur du site",
    items: [
      { label: "Dénomination sociale", value: "Trilogie SRL" },
      { label: "Forme juridique", value: "Société à Responsabilité Limitée (SRL)" },
      { label: "Responsable légal", value: "Thomas Kozera" },
      { label: "Siège social", value: "Rue des Vennes 42, 4020 Liège, Belgique" },
      { label: "Numéro BCE", value: "1027.143.589" },
      { label: "Numéro TVA", value: "BE 1027.143.589" },
    ],
  },
  {
    number: "02",
    title: "Contact",
    items: [
      { label: "E-mail", value: "Trilogie.restaurant@gmail.com", href: "mailto:Trilogie.restaurant@gmail.com" },
      { label: "Téléphone", value: "+32 470 45 36 93", href: "tel:+32470453693" },
      { label: "Adresse", value: "Rue des Vennes 42, 4020 Liège" },
    ],
  },
  {
    number: "03",
    title: "Hébergement",
    items: [
      { label: "Hébergeur", value: "OVH SAS" },
      { label: "Adresse", value: "2 rue Kellermann, 59100 Roubaix, France" },
      { label: "Site web", value: "www.ovhcloud.com", href: "https://www.ovhcloud.com" },
    ],
  },
  {
    number: "04",
    title: "Propriété intellectuelle",
    text: "L'ensemble du contenu de ce site — textes, photographies, illustrations et logo — est la propriété exclusive de Trilogie SRL. Toute reproduction, représentation, modification ou exploitation, totale ou partielle, est interdite sans autorisation préalable écrite.",
  },
  {
    number: "05",
    title: "Limitation de responsabilité",
    text: "Trilogie SRL s'efforce d'assurer l'exactitude et la mise à jour des informations diffusées sur ce site. Les informations relatives aux horaires, menus et tarifs sont données à titre indicatif et peuvent être modifiées sans préavis.",
  },
  {
    number: "06",
    title: "Droit applicable",
    text: "Le présent site et ses mentions légales sont soumis au droit belge. En cas de litige, les tribunaux compétents de l'arrondissement de Liège seront seuls compétents.",
  },
];

function MentionsLegales() {
  const itemsRef = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          }
        });
      },
      { threshold: 0.12 }
    );

    itemsRef.current.forEach((el) => el && observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <main className="mentions-page">

      {/* ── Hero ──────────────────────────────────────────────── */}
      <header className="mentions-hero">
        <div className="mentions-hero-inner">
          <span className="mentions-eyebrow">Informations légales</span>
          <h1 className="mentions-title">
            Mentions <em>légales</em>
          </h1>
          <div className="mentions-divider" />
          <p className="mentions-subtitle">
            Conformément à la législation belge et au Code de droit économique,
            voici les informations légales relatives à ce site.
          </p>
        </div>
        <div className="mentions-hero-deco" aria-hidden="true">
          <span>ML</span>
        </div>
      </header>

      {/* ── Sections ──────────────────────────────────────────── */}
      <div className="mentions-content">
        {sections.map((section, idx) => (
          <article
            key={section.number}
            className="mentions-section reveal"
            ref={(el) => (itemsRef.current[idx] = el)}
          >
            <div className="mentions-section-left">
              <span className="mentions-section-number">{section.number}</span>
              <div className="mentions-section-bar" />
            </div>

            <div className="mentions-section-right">
              <h2 className="mentions-section-title">{section.title}</h2>

              {section.items && (
                <dl className="mentions-dl">
                  {section.items.map((item) => (
                    <div className="mentions-dl-row" key={item.label}>
                      <dt className="mentions-dt">{item.label}</dt>
                      <dd className="mentions-dd">
                        {item.href ? (
                          <a href={item.href} className="mentions-link">
                            {item.value}
                          </a>
                        ) : (
                          item.value
                        )}
                      </dd>
                    </div>
                  ))}
                </dl>
              )}

              {section.text && (
                <p className="mentions-text">{section.text}</p>
              )}
            </div>
          </article>
        ))}
      </div>

      {/* ── Footer strip ──────────────────────────────────────── */}
      <div className="mentions-footer-strip">
        <p>© {new Date().getFullYear()} Trilogie SRL · Rue des Vennes 42, 4020 Liège</p>
      </div>

    </main>
  );
}

export default MentionsLegales;
